import React from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../config/config';
import { EDUCATION_LEVEL_OPTIONS } from '../../candidatePortal/constants/options';

function Form() {
    const { selectionProcessId } = useParams();
    const pathFrontEnd = selectionProcessId
        ? `/psp-selectionprocesses/${selectionProcessId}/vacancies/`
        : '/psp-selectionprocesses/vacancies/';
    const pathBackEnd = config.endpoints.backend + 'psp/selectionprocessvacancies/';

    const form = {
        labelTitleEdit: 'Editar Vaga do Processo Seletivo',
        labelTitleView: 'Visualizar Vaga do Processo Seletivo',
        labelTitleAdd: 'Nova Vaga',
        pathView: pathFrontEnd + 'view',
        urlGoBack: pathFrontEnd + 'list',
        endpointGetById: pathBackEnd + 'getById',
        endpointSave: pathBackEnd + 'save',
        validateOnChange: true,
        hiddenValues: selectionProcessId ? { psp_selection_process_id: selectionProcessId } : {},
        fields: [
            {
                name: 'psp_selection_process_id',
                label: 'Processo Seletivo',
                type: 'select',
                columnSize: 6,
                readOnly: !!selectionProcessId,
                defaultValue: selectionProcessId || undefined,
                options: [],
                optionsEndpoint: {
                    endpoint: config.endpoints.backend + 'psp/selectionprocesses/getall',
                    label: 'title',
                    value: 'id'
                },
                validations: {
                    required: true
                }
            },
            {
                name: 'psp_role_id',
                label: 'Função / Cargo',
                type: 'select',
                columnSize: 6,
                options: [],
                optionsEndpoint: {
                    endpoint: config.endpoints.backend + 'psp/roles/getall',
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                }
            },
            {
                name: 'title',
                label: 'Título da Vaga',
                type: 'text',
                placeholder: 'Ex: Enfermeira Pediátrica',
                columnSize: 12,
                validations: {
                    required: true
                }
            },
            {
                name: 'description',
                label: 'Descrição Geral da Vaga',
                type: 'textarea',
                columnSize: 12,
                validations: {
                    required: true
                }
            },
            {
                name: 'responsibilities_and_duties',
                label: 'Responsabilidades e Atribuições',
                type: 'textarea',
                columnSize: 6,
                validations: {
                    required: false
                }
            },
            {
                name: 'requirements_and_qualifications',
                label: 'Requisitos e Qualificações (Obrigatórios)',
                type: 'textarea',
                columnSize: 6,
                validations: {
                    required: false
                }
            },
            {
                name: 'academic_background',
                label: 'Formação Acadêmica Exigida',
                type: 'select',
                columnSize: 4,
                options: EDUCATION_LEVEL_OPTIONS.map((level) => ({ label: level, value: level })),
                validations: {
                    required: false
                }
            },
            {
                name: 'behavioral_skills',
                label: 'Competências Comportamentais',
                type: 'textarea',
                columnSize: 4,
                validations: {
                    required: false
                }
            },
            {
                name: 'requirements_desirable',
                label: 'Requisitos Desejáveis (Opcional)',
                type: 'textarea',
                columnSize: 4,
                validations: {
                    required: false
                }
            },
            {
                name: 'has_exam',
                label: 'Esta vaga terá etapa de Prova (Técnica ou Prática)?',
                type: 'checkbox',
                switch: true,
                columnSize: 12,
                validations: {
                    required: false
                }
            },
            {
                name: 'exam_date',
                label: 'Data Estimada da Prova',
                type: 'date',
                columnSize: 4,
                validations: {
                    required: false
                }
            },
            {
                name: 'exam_type',
                label: 'Formato da Prova',
                type: 'select',
                columnSize: 4,
                options: [
                    { label: 'Prova Teórica (Objetiva)', value: 'Prova Teórica (Objetiva)' },
                    { label: 'Prova Prática / Dinâmica', value: 'Prova Prática / Dinâmica' }
                ],
                validations: {
                    required: false
                }
            },
            {
                name: 'exam_local',
                label: 'Local da Prova',
                type: 'text',
                placeholder: 'Endereço ou plataforma online',
                columnSize: 4,
                validations: {
                    required: false
                }
            },
            {
                name: 'exam_instructions',
                label: 'Instruções da Prova',
                type: 'textarea',
                columnSize: 12,
                validations: {
                    required: false
                }
            },
            {
                name: 'files',
                type: 'multiUploadFileS3',
                label: 'Anexos da Vaga',
                uploadPath: 'psp/vacancies',
                limitFileSize: 20,
                uploadFileLimit: 10,
                validations: {
                    required: false
                },
                columnSize: 12
            }
        ]
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
